import { useTranslation } from 'react-i18next';
import useFeatureFlag from '../../../../common/use-feature-flag';
import { GROUP_ALIAS_TYPES } from '../../../../models/content/helpers';
import { Feature } from '../../../../models/features/features';
import { Avatar, Link } from '../../../ui';

const ChannelContributorsList = ({ channelContributors }) => {
  const { t } = useTranslation();
  const authorAliasNavEnabled = !!useFeatureFlag(Feature.AUTHOR_ALIAS_NAV_FIX);

  return (
    <div className="channel-details-v2__contributors-list">
      {channelContributors.map((contributor) => {
        const isGroupAlias = GROUP_ALIAS_TYPES.includes(contributor.alias_type);
        const href =
          authorAliasNavEnabled && isGroupAlias && contributor.author_alias_id
            ? `/aliases/${contributor.author_alias_id}`
            : contributor.id
            ? `/profiles/${contributor.id}`
            : null;

        const key =
          contributor.author_alias_id ||
          contributor.id ||
          contributor.display_name;

        const content = (
          <>
            <div className="channel-details-v2__contributor-avatar">
              <Avatar
                src={contributor.avatar_url}
                bgColor={contributor.avatar_color}
                alt={contributor.display_name}
              />
            </div>
            <div className="channel-details-v2__contributor-details">
              <div className="channel-details-v2__contributor-name">
                {contributor.display_name}
              </div>
              <div className="channel-details-v2__contributor-post_count">
                {t('channel_details.number_post', {
                  count: contributor.post_count,
                })}
              </div>
            </div>
          </>
        );

        return href ? (
          <Link
            key={key}
            href={href}
            action="push"
            className={'channel-details-v2__contributor'}
          >
            {content}
          </Link>
        ) : (
          <div key={key} className={'channel-details-v2__contributor'}>
            {content}
          </div>
        );
      })}
    </div>
  );
};

export default ChannelContributorsList;
